import { render, staticRenderFns } from "./EmployerOtherFundingFrequencySelect.vue?vue&type=template&id=3b58aaf5&"
import script from "./EmployerOtherFundingFrequencySelect.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherFundingFrequencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports